module.exports = __webpack_public_path__ + "static/media/Checkbox_.eb1219eb.svg";